<template>
  <div>
    <Top />
    <div class="maindiv zindex-wrap">
      <div class="tydiv tcenter" :class="{ 'spt': isTz && news.length > 0 ? true : false }">
        <div class="htmldiv">
          <div class="sdiv bgw dinline-block br5 vtop tleft mr10">
            <div class="ig dinline-block vtop br50 mt10"></div>
            <div class="txt dinline-block vtop ml20">
              <div class="fs40 fbold tc-blue3 mb5">培训报名</div>
              <div class="tc6">仅限台职院在校生</div>
              <div>
                <router-link to="/zedu/bm" class="zbtn zbtn-bblue3 br20 mt15 trans3">立即报名</router-link>
              </div>
            </div>
          </div>
          <div class="sdiv bgw dinline-block br5 vtop tleft mr10">
            <div class="ig dinline-block vtop br50 mt10"></div>
            <div class="txt dinline-block vtop ml20">
              <div class="fs40 fbold tc-blue3 mb5">查询</div>
              <div class="tc6">已有&nbsp;{{ info.enroll_count }}&nbsp;人查询报名及缴费</div>
              <div>
                <router-link to="/zedu/search" class="zbtn zbtn-bblue3 br20 mt15 trans3">立即查询</router-link>
              </div>
            </div>
          </div>
          <a :href="info.promotion_apply_link" target="_blank" class="ak dinline-block vtop ofhidden">
            <img class="trans hbig" src="../../../assets/images/ot_03.png" alt="">
          </a>
          <div v-if="isTz && news.length > 0" class="dinline-block" style="width: 100%;text-align: center;">
            <div class="dinline-block br5 cont tleft" style="margin-top: 10px;padding: 40px 20px 30px;width: 992px;background: #fff;">
              <Item v-for="(item, index) in news" :key="index" :index="index" :item="item" />
              <!--暂时放一下-->
                <Pagec v-if="total > 0" :pagen="page" :size="size" :total="total" :pageClass="'page-blue'"
                  @get-data="getData" />
            </div>

          </div>

        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
<script>
import Top from '../top.vue'
import Bottom from '../bottom.vue'
import Item from "../notice/item";
import Pagec from "@/components/index/page";
export default {
  name: "index",
  data() {
    return {
      info: {
        query_count: 0,
        enroll_count: 0,
        promotion_apply_link: '',
      },
      isTz: false, //台职
      news: [],
      page: 1,
      size: 2,
      total: 0,
    }
  },
  components: {
    Top,
    Bottom,
    Item,
    Pagec
  },
  created() {
    this.domain = document.domain
    if (this.domain == 'tzvtc.cjnep.net' || this.domain == 'jxjy.tzvtc.edu.cn'){//台职
      this.isTz = true
      this.getNotices()
    } 
    this.$request.get('promotion-apply/statistic-count', {}, response => {
      if (response.status == 200) {
        this.info = response.data.data;
      }
    }, error => {
      console.log(error);
    })
  },
  methods: {
    getNotices() {
      var getParam = {};
      getParam['theme'] = 7;
      getParam['type'] = 2;
      getParam['page'] = this.page - 1;
      getParam['size'] = this.size;
      this.$request.get('article/list', getParam, response => {
        if (response.status == 200) {
          this.news = response.data.data.noticeList;
          this.total = response.data.data.count;
        }
      }, error => {
        console.log(error);
      })
    },
    getData(page){
      this.page = page
      this.getNotices()
    },
  }
}
</script>

<style scoped>
.tydiv {
  padding-top: 205px;
  height: 745px;
  background: url(../../../assets/images/ot_02.jpg) no-repeat center top;
}

.tydiv.spt {
  padding-top: 20px;
}

.tydiv .ig {
  width: 100px;
  height: 100px;
  background: #f4f6f8 url(../../../assets/images/cn3.png) -198px -25px no-repeat;
}

.tydiv .sdiv:nth-child(2) .ig {
  background-position: -200px -160px;
}

.tydiv .txt {
  width: 230px;
}

.tydiv .sdiv:hover,
.tydiv .ak:hover {
  box-shadow: 0 0 15px #666;
}

.tydiv .sdiv {
  padding-top: 50px;
  padding-left: 40px;
  width: 400px;
  height: 220px;
}

.tydiv .ak {
  width: 162px;
  height: 220px;
}

.tydiv .zbtn {
  padding: 5px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/zedu/index/index.vue